import React from 'react';
import './OverlayAmbiente.css';

const OverlayAmbiente = ({ ambiente, onClose }) => {
  const getAmbienteInfo = (ambiente) => {
    switch (ambiente) {
      case 'Family Room':
        return {
          title: 'Family Room',
          subtitle: '2do nivel',
          description: 'Un espacio acogedor para compartir en familia, relajarte y disfrutar momentos cotidianos con comodidad.',
          features: [
            'Ambiente flexible para entretenimiento',
            'Iluminación cálida y confortable',
            'Diseño pensado para la convivencia'
          ]
        };
      case 'Sala':
        return {
          title: 'Sala',
          description: 'El corazón de tu hogar. Un espacio diseñado para crear momentos inolvidables con familia y amigos.',
          features: [
            'Amplio espacio de convivencia',
            'Ventanas que maximizan la luz natural',
            'Diseño moderno y funcional',
            'Ideal para reuniones familiares'
          ]
        };
      case 'Dormitorio':
        return {
          title: 'Dormitorio',
          description: 'Tu refugio personal. Un espacio íntimo diseñado para el descanso y la tranquilidad.',
          features: [
            'Diseño acogedor y relajante',
            'Ventilación natural optimizada',
            'Espacio para mobiliario completo',
            'Iluminación suave y funcional'
          ]
        };
      case 'Patio':
        return {
          title: 'Terraza',
          description: 'Tu conexión con la naturaleza. Un espacio exterior que complementa perfectamente tu vida interior.',
          features: [
            'Área de recreación al aire libre',
            'Espacio para jardín personal',
            'Ideal para actividades familiares',
            'Diseño integrado con la naturaleza'
          ]
        };
      default:
        return {
          title: 'Ambiente',
          description: 'Descubre este espacio único de tu nuevo hogar.',
          features: []
        };
    }
  };

  const info = getAmbienteInfo(ambiente);

  return (
    <div className="overlay-ambiente">
      <div className="overlay-ambiente-content">
        <img
          src={process.env.PUBLIC_URL + '/Logo/logo-nuevo-Garden-1 1.png'}
          alt="Logo Garden"
          className="overlay-ambiente-logo"
        />
        <h1 className="overlay-ambiente-title">{info.title}</h1>
        {info.subtitle && (
          <div className="overlay-ambiente-subtitle">{info.subtitle}</div>
        )}
        <p className="overlay-ambiente-desc">{info.description}</p>
        
        {info.features.length > 0 && (
          <div className="overlay-ambiente-features">
            <h3>Características principales:</h3>
            <ul>
              {info.features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </div>
        )}
        
        <button className="overlay-ambiente-back-btn" onClick={onClose}>
        <span className="material-symbols-outlined">arrow_back</span>
        </button>
      </div>
    </div>
  );
};

export default OverlayAmbiente; 